import React, { ReactElement } from 'react';
import { clsx } from 'clsx';
import blurText from '../../helpers/blurText';
import { SvgIconProps } from '../icons/SvgIcon';

type Props = {
  icon: ReactElement<SvgIconProps>;
  text: string;
  subtitle?: string;
  isBlurred?: boolean;
};

export default function KeyDetail({ icon, text, subtitle, isBlurred }: Props) {
  return (
    <div className="flex flex-row items-center min-h-[3rem]">
      <h3>{icon}</h3>
      <div className={clsx('flex flex-col ml-4', isBlurred && 'blur-md')}>
        <p className="m-0">{blurText(text, isBlurred)}</p>
        {Boolean(subtitle) && (
          <p className="text-sm text-secondaryText">
            {blurText(subtitle, isBlurred)}
          </p>
        )}
      </div>
    </div>
  );
}
